import isEmpty from 'lodash/isEmpty'
import { MemberScopeFarm, MemberScopes } from 'modules/member/api/types'

export const transformFarmsData = (farms: MemberScopeFarm[]): MemberScopes[] => {
  if (isEmpty(farms)) {
    return []
  }

  const result: MemberScopes[] = []

  farms.forEach((farm) => {
    result.push({
      scope_name: 'Farm',
      data_id: farm.id,
    })

    farm.ponds?.forEach((pond) => {
      if (pond.id && pond.name) {
        result.push({
          scope_name: 'Pond',
          data_id: pond.id,
        })
      }
    })
  })

  return result
}
